var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { IsNullOrEmpty } from './str.helper';
import { HttpAuthTokenHelper } from './token.helper';
export class RefreshTokenTracker {
    static initUserActivityTracker() {
        var timeoutTime = 1000 * 60 * 5; // 5mn => 300 000
        RefreshTokenTracker.ActivityTimer = setTimeout(RefreshTokenTracker.markUserInactive, timeoutTime);
        if (!RefreshTokenTracker.ListenerInitialized) {
            document.addEventListener('click', function () {
                RefreshTokenTracker.IsUserActive = true;
                if (!RefreshTokenTracker.IsTokenIntervalRunning) {
                    RefreshTokenTracker.initTokenExpirationTimer(RefreshTokenTracker.RefreshAction, RefreshTokenTracker.UserModule);
                }
                clearTimeout(RefreshTokenTracker.ActivityTimer);
                RefreshTokenTracker.ActivityTimer = setTimeout(RefreshTokenTracker.markUserInactive, timeoutTime);
                if (RefreshTokenTracker.UserModule) {
                    const token = HttpAuthTokenHelper.getAccessTokenFromLocalStorage();
                    const isExpiredFromLessThanOneHour = HttpAuthTokenHelper.isExpiredFromLessThanOneHour(token);
                    if (isExpiredFromLessThanOneHour) {
                        RefreshTokenTracker.UserModule.setNeedToReconnect(true);
                    }
                    else {
                        RefreshTokenTracker.UserModule.setNeedToReconnect(false);
                        if (HttpAuthTokenHelper.isExpired(token)) {
                            RefreshTokenTracker.UserModule.setNeedToDeconnect(true);
                        }
                    }
                }
            });
            RefreshTokenTracker.ListenerInitialized = true;
        }
    }
    static markUserInactive() {
        RefreshTokenTracker.IsUserActive = false;
        clearTimeout(RefreshTokenTracker.ActivityTimer);
    }
    static initTokenExpirationTimer(refreshAction, userModule = null, canReconnect = false) {
        RefreshTokenTracker.RefreshAction = refreshAction;
        RefreshTokenTracker.initUserActivityTracker();
        if (userModule) {
            RefreshTokenTracker.UserModule = userModule;
        }
        const token = HttpAuthTokenHelper.getAccessTokenFromLocalStorage();
        if (IsNullOrEmpty(token) || (!canReconnect && HttpAuthTokenHelper.isExpired(token) || canReconnect && HttpAuthTokenHelper.isExpiredSinceOneHour(token))) {
            RefreshTokenTracker.KnownToken = null;
            return;
        }
        if (RefreshTokenTracker.KnownToken === token) {
            return;
        }
        var timeoutTime = RefreshTokenTracker.getFirstExpirationTimeout();
        clearTimeout(RefreshTokenTracker.TokenTimer);
        RefreshTokenTracker.IsTokenIntervalRunning = true;
        RefreshTokenTracker.TokenTimer = setTimeout(_ => RefreshTokenTracker.refreshToken(refreshAction), timeoutTime);
    }
    static getFirstExpirationTimeout() {
        const realDelay = (HttpAuthTokenHelper.getExpirationTime() - Math.floor(new Date().getTime() / 1000)) * 1000;
        // 1000 is 1 sec, security to avoid negative timer
        if (realDelay < (RefreshTokenTracker.MinRefreshInterval + 1000)) {
            // if token will expire very soon, proceed to refresh token with no delay
            return 500;
        }
        let lastChanceTime = realDelay - RefreshTokenTracker.MinRefreshInterval;
        return lastChanceTime;
    }
    static refreshToken(refreshAction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (RefreshTokenTracker.IsUserActive) {
                // call refresh token
                const refreshToken = HttpAuthTokenHelper.getRefreshTokenFromLocalStorage();
                const decodedToken = HttpAuthTokenHelper.decode();
                if (!IsNullOrEmpty(refreshToken)) {
                    var result = yield refreshAction(refreshToken, decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.idu);
                    if (result) {
                        var newToken = HttpAuthTokenHelper.mapReceivedToken(result);
                        RefreshTokenTracker.KnownToken = newToken.accessToken;
                        HttpAuthTokenHelper.setToken(newToken);
                        RefreshTokenTracker.TokenTimer = setTimeout(_ => RefreshTokenTracker.refreshToken(refreshAction), RefreshTokenTracker.MaxRefreshInterval);
                        return;
                    }
                }
            }
            RefreshTokenTracker.IsTokenIntervalRunning = false;
            clearTimeout(RefreshTokenTracker.TokenTimer);
        });
    }
}
RefreshTokenTracker.IsUserActive = true;
RefreshTokenTracker.ListenerInitialized = false;
RefreshTokenTracker.IsTokenIntervalRunning = true;
RefreshTokenTracker.MaxRefreshInterval = 1000 * 60 * 8;
RefreshTokenTracker.MinRefreshInterval = 1000 * 60 * 2;
RefreshTokenTracker.UserModule = null;
